import { useMemo } from "react";
import { useSelector } from "react-redux";
import { AXNUICustomLandingPage } from "@iddataweb/idw-common-ui/containers";
import { getLandingPageContentAndLayout } from "@iddataweb/idw-common-ui/utils";
import { getLanguageContent } from "@redux/selectors/language-selectors";
import { getLandingPageData, getRedirectUrl } from "@redux/selectors/common-selectors";
import {
    getAsi,
    getConfigurationLayout,
    getConfigurationTheme,
    getFormPanelLayout,
    getIDPName,
    getLogoPosition,
    getLogoUrl,
    getRPName,
    getUseThemedUI
} from "@redux/selectors/verification-configuration-selectors";

export const CustomLandingPage = () => {
    const useThemedUI = useSelector(getUseThemedUI);
    const landingPageData = useSelector(getLandingPageData);
    const layout = useSelector(getConfigurationLayout);
    const asi = useSelector(getAsi);
    const redirectUrl = useSelector(getRedirectUrl);
    const content = useSelector(getLanguageContent);
    const idpName = useSelector(getIDPName);
    const relyingPartyName = useSelector(getRPName);
    const logoUrl = useSelector(getLogoUrl);
    const logoPosition = useSelector(getLogoPosition);
    const theme = useSelector(getConfigurationTheme);
    const formPanelLayout = useSelector(getFormPanelLayout);

    const redirectUrlWithoutHostname = useMemo(() => {
        if (!redirectUrl.includes("[mockrp2-base]")) {
            return `[mockrp2-base]/${redirectUrl}`;
        }
        return redirectUrl;
    }, [redirectUrl]);

    const {
        approveMessageHTML,
        denyMessageHTML,
        asiLabel,
        showAsiLabel,
        noDecisionMessage
    } = useMemo(() => {
        return getLandingPageContentAndLayout(content, layout, redirectUrlWithoutHostname);
    }, [content, layout, redirectUrlWithoutHostname]);

    return (
        <AXNUICustomLandingPage
            approveMessageHTML={approveMessageHTML}
            denyMessageHTML={denyMessageHTML}
            asi={asi}
            asiLabel={asiLabel}
            showAsiLabel={showAsiLabel}
            noDecisionMessage={noDecisionMessage}
            policyDecision={landingPageData.policyDecision}
            formPanelContent={content.formPanel}
            formPanelLayout={formPanelLayout}
            formPanelTheme={theme.formPanel}
            defaultFontFamily={theme.general.font}
            defaultTextColor={theme.general.mainTextColor}
            idpName={idpName}
            logoPosition={logoPosition}
            logoUrl={logoUrl}
            relyingPartyName={relyingPartyName}
            useThemedUI={useThemedUI}
        />
    );
};